export default "__VITE_ASSET__wHaSICM6__"